import internal from "assert"

export interface Translations {
  en?: string,
  zh_Hant?: string,
  zh_Hant_HK?:string
}

export interface SendNotificationToUserResponse {
  cannotDeliverToUserId: number[];
  sentToUserIds: number[]
}

export interface ITodoModel {
  id: string;
  text: string;
  completed: false;
}

export type ErrorObj = {
  errorCode: string;
  errorMessage: string;
  payload?: any;
}


export type UserEntityResponse = MyResponse<UserEntity>

export type MyResponse<T> = {
    error?: ErrorObj;
    message?: T ;
    status: boolean;
}

export type UserEntity = {
  authByEmailPassword?: AuthByEmailPassword;
  authByFacebook?: any;
  authByGoogle?: any;
  authByPhoneNumberSchema: AuthByPhoneNumberSchema;
  createdAt: string;
  credit: number;
  creditBalance: number;
  creditSpent: number;
  dateOfBirth: string;
  email: string;
  firstName: string;
  gender?: any;
  id: number;
  lastName: string;
  locale: string;
  profileImage: Image;
  token: string;
  tokenExpiryTime: string;
  type?: any;
  userSettings: UserSettings;
  username: string;
}

export type UserSettings = {
  allowNotification: boolean;
  id: number;
}

export type Image = {
  id: number;
  name?: any;
  objKey: string;
  slugifiedName?: any;
  url: string;
}

export interface AuthByPhoneNumberSchema {
  countryCode: string;
  subscriberNumber: string;
}

export interface AuthByEmailPassword {
  email: string;
  verified: boolean;
}

export interface Pagination<T> {
  total: number,
  hasNext: boolean;
  hasPrev: boolean;
  itemCount: number;
  items?: T [];
  nextNum: number;
  pages: number;
  prevNum?: any;
}

export type Game  = {
  id: number;
  active: boolean;
  published: boolean;
  startTime: String;
  endTime: String;
  gameBanners: GameBanner[] | null;
  gamePrizes: GamePrize[] | null;
}

export type PrizeBanner = {
  id: number;
  imageId: number;
  prizeId: number;
  tag: number;
  priority: number;
}

export type GameBanner = {
  id: number;
  image: Image;
  published: boolean;
  url: string;
}

export interface PhoneNumber {
  areaCode: string;
  countryCode: string;
  id: number;
  subscriberNumber: string;
}

export interface SpotRelatedIds {
  couponBannerIds: number[] | string [],
  couponIds: number[] | string [],
  qrCodeEntityIds: number[] | string[],
  spotBannerIds: number[] | string [],
  spotId: number
}

export interface Spot {
  active: boolean;
  allowedPeriodDescriptionTranslations?: AllowedPeriodDescriptionTranslations;
  availablePeriodDescription: string;
  businesses?: Business[];
  category: District;
  description: string;
  descriptionTranslations: AllowedPeriodDescriptionTranslations;
  district: District;
  id: number;
  images?: Image[];
  location: Location;
  name?: string;
  nameTranslations: AllowedPeriodDescriptionTranslations;
  phoneNumber?: PhoneNumber;
  qrCodeEntities?: QRCodeEntity[];
  region: District;
  squareImage?: Image;
  squareImageId: number;
  tags: Tag[];
  locationId?: number;
  websiteUrlId?: number;
  websiteUrl?: URL;
  instagramUrlId?: number;
  instagramUrl?: URL;
  facebookUrlId?: number;
  facebookUrl: URL;
}

export interface URL {
  id: number;
  value: string;
}

interface AllowedPeriodDescriptionTranslations {
  en?: string;
  'zh-Hant-HK'?: string;
  'zh-Hant'?: string;
}

interface CorrespondingQRCode {
  code: string;
  periodEndTime: string;
  periodStartTime: string;
  qrPeriodId: number;
  url: string;
}

export interface QRCodeEntityStats {
  numberOfScan: number
}

export interface Website{
  type: string;
  url: string;
}

export interface QRCodeEntity {
  correspondingQRCodes? : CorrespondingQRCode[]
  active: boolean;
  correspondingQrCode: CorrespondingQrCode[];
  endTime: string;
  id: number;
  rewardBundle: RewardBundle;
  startTime: string;
  tags: Tag[];
  qrPeriods: QRPeriod[];
  scanRules: ScanRule[];
}

export interface QRPeriod {
  id: number;
  startTime: string;
  endTime: string;
  periodKey: string;
  shortenUrl: string;
}

export interface RewardBundle {
  coupons: Coupon[];
  creditReward: CreditReward;
  id: number;
  toBeCollected: boolean;
  actionUrl: string;
}

export interface CreditReward {
  active: boolean;
  amountOfCredit: string;
  id: number;
  maximumAmount: number;
  name: string;
}

interface CorrespondingQrCode {
  code: string;
  periodEndTime: string;
  periodStartTime: string;
  url: string;
}

export interface BusinessBranch {
  id: number;
  active: boolean;
  closingHour?: string;
  coupons: Coupon[];
  description?: string;
  district?: District;
  location?: Location;
  name?: string;
  openingHour?: string;
  phoneNumber?: PhoneNumber;
}

export type Business = {
  businessBranches: BusinessBranch[];
  businessIcon?: Image;
  description: string;
  id: number;
  name: string;
}

export interface Location {
  description?: any;
  id: number;
  latitude: string;
  longitude: string;
  name?: string;
}

interface District {
  id: number;
  name: string;
}

export type RedemptionType = 'online' | 'offline';

export interface Coupon {
  active: boolean;
  allowedPeriodDescription: string;
  allowedPeriodEnd: string;
  allowedPeriodStart?: string;
  backgroundImage?: Image;
  description?: string;
  expired: boolean;
  howToUse: string;
  id: number;
  images: Image[];
  maximumAmount: number;
  name: string;
  phoneNumber: PhoneNumber;
  phoneNumberId?: number;
  redemptionType?: RedemptionType;
  shortDescription: string;
  slogan1?: string;
  slogan2?: string;
  squareImage: Image;
  squareImageId: number;
  termAndConditions: string;
  validUntil: string;
}

export interface CouponForAdminExtension {
  descriptionTranslations?: Translations,
  shortDescriptionTranslations?: Translations,
  howToUseTranslations?: Translations,
  nameTranslations?: Translations,
  slogan1Translations?: Translations,
  slogan2Translations?: Translations,
  termAndConditionsTranslations?: Translations
}

export interface CouponForAdmin extends Partial<Coupon> , CouponForAdminExtension {}

export interface CreateCouponParameter extends CouponForAdmin {
  imageIds?: number[],
  businessBranchIds?: number[]
}


export type ApiData<Data> = {
  cached?: Data,
  loading: boolean
}

export type ApiPaginatedData<Item> = ApiData<Pagination<Item>>

export interface ShippingOrder {
  address: string;
  createdAt: string;
  email: string;
  gamePrizeRedemptionHistory?: GamePrizeRedemptionHistory;
  givenName: string;
  id: number;
  lastName: string;
  phoneNumber: PhoneNumber;
  prize: Prize;
  prizeRedemptionHistory?: PrizeRedemptionHistory;
  shippingMethod: ShippingMethod;
  status: number;
  userId: number;
}

interface GamePrizeRedemptionHistory {
  createdAt: string;
  gamePointSpent: number;
  gamePrizeId: number;
  id: number;
  shippingOrderId: number;
  userId: number;
}

interface PrizeRedemptionHistory {
  createdAt: string;
  creditSpent: number;
  prizeId: number;
  shippingOrderId: number;
  userId: number;
}

export interface GameStats {
  numberOfPlayer: number
  numberOfPlayerRedeemedGamePrize: 1
}

export interface GamePrize {
  prize: Prize;
  gamePoint: number;
  maximumAmount: number;
  published: boolean;
  gameId: number;
}

export interface Prize {
  brand: Business;
  description?: string;
  detailImage?: Image;
  id: number;
  listingImage?: Image;
  name: string;
  price: number;
  redemptionType?: RedemptionType;
  shippingMethods: ShippingMethod[];
  shortDescription?: string;
}

interface ShippingMethod {
  key: string;
  name: string;
}


export interface CouponOwnership {
  coupon: Coupon;
  id: number;
  redeemed: boolean;
  redeemedAt?: string;
  revoked: boolean;
  user?: UserEntity;
  userId: number;
  userLocation?: Location;
}


export type QRCodeUsageHistory = {
  id: number;
  qrCodeEntity: QRCodeEntity;
  user: UserEntity;
  userLocation: Location;
}

export type CouponBanner = {
  id: number,
  couponId: number,
  imageId: number,
  tag?: string
}

export type MajorBanner = {
  id: number,
  image: Image,
  url?: string,
  active: boolean  
}

export type SpotBanner = {
  id: number,
  spotId: number,
  imageId: number,
}

export type Tag = {
  id: number,
  value: string
}

export interface ArticleBlock {
  id: number;
  image: Image;
  htmlString?: any;
  routeUrl?: string;
  blockType: string;
}

export type ArticleBlockInputType = {
  htmlString?: string,
  imageId?: string,
  imageUrl?: string,
  routeUrl?: string,
}

export type ArticleInput = {
  title: string,
  mainImageId?: string,
  thumbnailImageId?: string,
  tagKeys: Array<string>,
  tagIds: Array<number>,
  blocks: Array<ArticleBlockInputType>
}

export type Article = {
  id: number,
  title: string,
  publishTime: string,
  mainImageId?: number,
  thumbnailImageId?: number,
  tags: Array<Tag>,
  blocks: Array<ArticleBlock>
}

export type ScanRule = {
  id: number,
  createdAt: string,
  startTime?: string,
  endTime?: string,
  priority?: number,
  qrCodeEntityId: number,
  rewardBundleId: number,
  type?: string,
  ruleConditions: Array<RuleCondition>
}

export type RuleCondition = {
  id: number,
  scanRuleId: number,
  type: string,
  valueInt: number,
  valueOperator: string,
}

export type ClientAction = {
  actionType: string,
  createdAt: string,
  id: number,
  objectId?: string,
  objectType?: string,
  updatedAt: string,
  kwargs: string | null
}

export type ClientTask = {
  actions: ClientAction[],
  extId: string,
  invocatorId: number,
  status: string,
  createdAt: string
}

export type MixedBanner = {
  id: number,
  coupon?: Coupon,
  image: Image,
  prize?: Prize,
  spot?: Spot,
  type: string,
  url?: string,
  priority?: number,
  published?: boolean,
  // Load-only request fields. The API dumps the nested objects (`image`), but
  // the admin grid and dialog also accept the flat ids on write.
  imageId?: number,
  spotId?: number,
  prizeId?: number,
  couponId?: number,
  // TASK-52: campaign banners (type=tag) carry N hashtags. `tag` is the legacy
  // single-tag field the backend keeps for one release; new clients read `tags`.
  tag?: Tag,
  tags?: Tag[],
  validFrom?: string | null,
  validUntil?: string | null
}

/** Banner types accepted by POST/PATCH /admin/mixed-banner. */
export const MIXED_BANNER_TYPES: ReadonlyArray<string> = ['spot', 'prize', 'coupon', 'url', 'tag']